import { Menu, Tooltip, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  loadMergeAPIExploreQueryBuilderSchema,
  loadMergeAPIExploreQueryBuilderSchemas,
} from '../../../../redux/actions/ioc';
import { TitleAction } from '../../shared-components/TitleAction';
import history from '../../../../redux/history';
import { changeTitle } from '../../../../redux/actions/app';
import { ReactComponent as queryBuilderIcon } from '../../../../assets/icons/Query_builder.svg';
import Icon, { PlusOutlined, EyeOutlined } from '@ant-design/icons';
import { STATUS } from '../../../../redux/constants';
import styles from '../LeftMenuSidebar/left-menu-sidebar.module.sass';
import cx from 'classnames';

export function QueryBuilderSubMenu(props) {
  const QueryBuilderIcon = (props) => <Icon component={queryBuilderIcon} />;
  const dispatch = useDispatch();
  const exploreSchemas = useSelector((state) => state.ioc.exploreSchemas);
  const schemasStatus = useSelector((state) => state.ioc.schemasStatus);
  const [queryBuilderSchemas, setQueryBuilderSchemas] = useState([]);
  const [
    templateQueryBuilderSchemas,
    setTemplateQueryBuilderSchemas,
  ] = useState([]);
  const [globalQueriesGroups, setGlobalQueriesGroups] = useState([]);
  const { Title, Text } = Typography;
  const { isKeyOn, setSessionStorage, toggleKey, ...rest } = props;

  useEffect(() => {
    // dispatch(loadMergeAPIExploreQueryBuilderSchemas());
  }, [window.location]);

  useEffect(() => {
    if (schemasStatus == STATUS.LOADED) {
      if (exploreSchemas && exploreSchemas.form_list) {
        const rootSchemas = exploreSchemas.form_list.filter(
          (f) => !f.form_parent_uuid,
        );
        setQueryBuilderSchemas(
          rootSchemas.map((r) => {
            r.children = exploreSchemas.form_list.filter(
              (f) => r.form_uuid === f.form_parent_uuid,
            );
            return r;
          }),
        );
        setTemplateQueryBuilderSchemas(
          exploreSchemas.form_list.filter((f) => f.scope === 'GLOBAL'),
        );
      }
    }
  }, [schemasStatus]);

  useEffect(() => {
    if (queryBuilderSchemas?.length > 0) {
      let groupNames = [];
      groupNames = queryBuilderSchemas?.map((query) => {
        return query.form_name?.split(' ')?.[0];
      });

      groupNames = groupNames?.filter(
        (item, index) => groupNames?.indexOf(item) === index,
      );
      setGlobalQueriesGroups(groupNames);
    }
  }, [queryBuilderSchemas]);

  const visualizedQueries = [
    '19eabdf7-eeeb-43e8-b110-8fd96fe2fbdb', //Domain name server changes
    // '337b7828-3adf-484d-a3ea-f9950755ca16', //"Domain search name server changes"
    '8d1aa841-bfa1-4160-a809-9d1063c8a0ef', //"Domain search"
    '370338a9-7485-40ef-9a43-508236e2306b', //"PADNS forward lookup"
    '71564dfd-d52a-4cf1-aab4-c7483af04ff6', //"PADNS IP Diversity lookup"
    'a426b767-3999-4419-aadc-bf510b3914cb', //"PADNS Live Unsanctioned Assets lookup"
    '60226683-52ed-4c6b-9f26-41f2918e76c0', //"PADNS multi-condition lookup"
    'ed2b8d10-23a1-4034-8f16-40331df5c56f', //"PADNS reverse lookup"
    // '86f77478-dcad-4452-9c6f-db70bd229c14', //"PADNS search self-hosted domains"
    'a55cf850-212f-457f-bcb6-e54ddf7ecce5', //"PADNS search SOA records"
    '40710e97-441d-4505-9902-a3a756072f71', //"Xperimental - autospoofing, advanced"
    '14a1e710-d31d-4d5e-ab4a-e1503e6987ce', //"Xperimental - autospoofing, simple"
    '8b10c9da-3980-40c4-8db5-96dc36d74c72', //"Xperimental - PADNS domain snapshot"
    '5e9b2b89-b94b-4d34-87ba-1f3ef9b4b132', //Xperimental - ssdeep get scandata
    'ed35069b-850b-4c1d-ba07-d690611c3947', //PADNS search ipdiversity patterns
  ];

  return (
    <Menu.SubMenu
      data-cy={`queryBuilderSubMenuAdvancedQueryBuilder`}
      title={
        <TitleAction
          menuKey={'query-builder'}
          title={
            <div className={styles.section_title}>
              <div className={styles.border} />
              <QueryBuilderIcon />
              <Title level={5}>Advanced Query Builder</Title>
            </div>
          }
          showDownArrow={props.isKeyOn('query-builder')}
        />
      }
      className={styles.main_menu_option}
      {...rest}
    >
      <Menu.SubMenu
        data-cy="queryBuilderSubMenuPrivateQueries"
        className={cx(styles.first_level_submenu, styles.exceptionBackground)}
        title={
          <TitleAction
            menuKey={'private-queries-submenu'}
            title={
              <Text className={styles.additional_indentation} strong>
                Private Queries
              </Text>
            }
            showDownArrow={props.isKeyOn('private-queries-submenu')}
            titleAction={() => props.toggleKey('private-queries-submenu')}
          />
        }
        onTitleClick={(e) => {
          props.toggleKey('private-queries-submenu');
        }}
        key={'private-queries-submenu'}
      >
        {queryBuilderSchemas.map((queryBuilderSchema) => {
          let privateQueries = queryBuilderSchema.children.filter(
            (queryBuilderSchemaSaved) =>
              queryBuilderSchemaSaved.scope == 'USER',
          );
          return privateQueries.map((privateQuery) => {
            return (!privateQuery.is_exposed &&
              props.mySubscriptionPlan?.has_limited_access_to_query_builder) ||
              !props.mySubscriptionPlan?.has_access_to_query_builder ? (
              props.returnSubstituteMenu({
                type: 'subMenuItem',
                tooltipMessage: (
                  <>
                    This Advanced Query is not part of this subscription plan.
                    To upgrade your subscription contact us at{' '}
                    <a target="_blank" href="mailto:sales@silentpush.com">
                      sales@silentpush.com
                    </a>
                    .
                  </>
                ),
                menuTitle: (
                  <>
                    {(visualizedQueries?.includes(privateQuery?.form_uuid) ||
                      visualizedQueries?.includes(
                        privateQuery?.form_parent_uuid,
                      )) && (
                      <>
                        <EyeOutlined />{' '}
                      </>
                    )}
                    {privateQuery.form_name}
                  </>
                ),
                icon: null,
              })
            ) : (
              <Menu.Item
                onClick={() => {
                  props.setSessionStorage(privateQuery.form_uuid);
                  history.push(
                    `/explore/query-builder/?query=${privateQuery.form_uuid}`,
                  );
                  dispatch(changeTitle(privateQuery.form_name, null));
                  dispatch(
                    loadMergeAPIExploreQueryBuilderSchema(
                      privateQuery.form_uuid,
                    ),
                  );
                }}
                key={privateQuery.form_uuid}
              >
                <TitleAction
                  menuKey={privateQuery.form_uuid}
                  title={
                    <>
                      <Tooltip
                        placement="right"
                        title={privateQuery?.form_description}
                      >
                        <Link
                          className={styles.secondary_section_title}
                          to={`/explore/query-builder/?query=${privateQuery.form_uuid}`}
                        >
                          <Text className={styles.additional_indentation}>
                            {(visualizedQueries?.includes(
                              privateQuery?.form_uuid,
                            ) ||
                              visualizedQueries?.includes(
                                privateQuery?.form_parent_uuid,
                              )) && (
                              <>
                                <EyeOutlined />{' '}
                              </>
                            )}
                            {privateQuery.form_name}
                          </Text>
                          {/* <PlusOutlined /> */}
                        </Link>
                      </Tooltip>
                    </>
                  }
                />
              </Menu.Item>
            );
          });
        })}
      </Menu.SubMenu>
      <Menu.SubMenu
        data-cy="queryBuilderSubMenuSharedQueries"
        className={cx(styles.first_level_submenu, styles.exceptionBackground)}
        title={
          <TitleAction
            menuKey={'shared-queries-submenu'}
            title={
              <Text className={styles.additional_indentation} strong>
                Shared Queries
              </Text>
            }
            showDownArrow={props.isKeyOn('shared-queries-submenu')}
            titleAction={() => props.toggleKey('shared-queries-submenu')}
          />
        }
        onTitleClick={(e) => {
          props.toggleKey('shared-queries-submenu');
        }}
        key={'shared-queries-submenu'}
      >
        {queryBuilderSchemas.map((queryBuilderSchema) => {
          let sharedQueries = queryBuilderSchema.children.filter(
            (queryBuilderSchemaSaved) =>
              queryBuilderSchemaSaved.scope == 'ORGANISATION',
          );
          return sharedQueries.map((sharedQuery) => {
            return (!sharedQuery.is_exposed &&
              props.mySubscriptionPlan?.has_limited_access_to_query_builder) ||
              !props.mySubscriptionPlan?.has_access_to_query_builder ? (
              props.returnSubstituteMenu({
                type: 'subMenuItem',
                tooltipMessage: (
                  <>
                    This Advanced Query is not part of this subscription plan.
                    To upgrade your subscription contact us at{' '}
                    <a target="_blank" href="mailto:sales@silentpush.com">
                      sales@silentpush.com
                    </a>
                    .
                  </>
                ),
                menuTitle: (
                  <>
                    {(visualizedQueries?.includes(sharedQuery?.form_uuid) ||
                      visualizedQueries?.includes(
                        sharedQuery?.form_parent_uuid,
                      )) && (
                      <>
                        <EyeOutlined />{' '}
                      </>
                    )}
                    {sharedQuery.form_name}{' '}
                  </>
                ),
                icon: null,
              })
            ) : (
              <Menu.Item
                onClick={() => {
                  props.setSessionStorage(sharedQuery.form_uuid);
                  history.push(
                    `/explore/query-builder/?query=${sharedQuery.form_uuid}`,
                  );
                  dispatch(changeTitle(sharedQuery.form_name, null));
                  dispatch(
                    loadMergeAPIExploreQueryBuilderSchema(
                      sharedQuery.form_uuid,
                    ),
                  );
                }}
                key={sharedQuery.form_uuid}
              >
                <TitleAction
                  menuKey={sharedQuery.form_uuid}
                  title={
                    <>
                      <Tooltip
                        placement="right"
                        title={sharedQuery?.form_description}
                      >
                        <Link
                          className={styles.secondary_section_title}
                          to={`/explore/query-builder/?query=${sharedQuery.form_uuid}`}
                        >
                          <Text className={styles.additional_indentation}>
                            {(visualizedQueries?.includes(
                              sharedQuery?.form_uuid,
                            ) ||
                              visualizedQueries?.includes(
                                sharedQuery?.form_parent_uuid,
                              )) && (
                              <>
                                <EyeOutlined />{' '}
                              </>
                            )}
                            {sharedQuery.form_name}{' '}
                          </Text>
                          {/* <PlusOutlined /> */}
                        </Link>
                      </Tooltip>
                    </>
                  }
                />
              </Menu.Item>
            );
          });
        })}
      </Menu.SubMenu>
      <Menu.SubMenu
        data-cy="queryBuilderSubMenuTemplateQueries"
        className={cx(styles.first_level_submenu, styles.exceptionBackground)}
        title={
          <TitleAction
            menuKey={'template-queries-submenu'}
            title={
              <Text className={styles.additional_indentation} strong>
                Template Queries
              </Text>
            }
            showDownArrow={props.isKeyOn('template-queries-submenu')}
            titleAction={() => props.toggleKey('template-queries-submenu')}
          />
        }
        onTitleClick={(e) => {
          props.toggleKey('template-queries-submenu');
        }}
        key={'template-queries-submenu'}
      >
        {templateQueryBuilderSchemas?.map((templateQueryBuilderSchema) => {
          return (!templateQueryBuilderSchema.is_exposed &&
            props.mySubscriptionPlan?.has_limited_access_to_query_builder) ||
            !props.mySubscriptionPlan?.has_access_to_query_builder ? (
            props.returnSubstituteMenu({
              type: 'subMenuItem',
              tooltipMessage: (
                <>
                  This Advanced Query is not part of this subscription plan. To
                  upgrade your subscription contact us at{' '}
                  <a target="_blank" href="mailto:sales@silentpush.com">
                    sales@silentpush.com
                  </a>
                  .
                </>
              ),
              menuTitle: (
                <>
                  {(visualizedQueries?.includes(
                    templateQueryBuilderSchema?.form_uuid,
                  ) ||
                    visualizedQueries?.includes(
                      templateQueryBuilderSchema?.form_parent_uuid,
                    )) && (
                    <>
                      <EyeOutlined />{' '}
                    </>
                  )}
                  {templateQueryBuilderSchema.form_name}{' '}
                </>
              ),
              icon: null,
            })
          ) : (
            <Menu.Item
              onClick={() => {
                props.setSessionStorage(templateQueryBuilderSchema.form_uuid);
                history.push(
                  `/explore/query-builder/?query=${templateQueryBuilderSchema.form_uuid}`,
                );
                dispatch(
                  changeTitle(templateQueryBuilderSchema.form_name, null),
                );
                dispatch(
                  loadMergeAPIExploreQueryBuilderSchema(
                    templateQueryBuilderSchema.form_uuid,
                  ),
                );
              }}
              key={templateQueryBuilderSchema.form_uuid}
            >
              <TitleAction
                menuKey={templateQueryBuilderSchema.form_uuid}
                title={
                  <>
                    <Tooltip
                      placement="right"
                      title={templateQueryBuilderSchema?.form_description}
                    >
                      <Link
                        className={styles.secondary_section_title}
                        to={`/explore/query-builder/?query=${templateQueryBuilderSchema.form_uuid}`}
                      >
                        <Text className={styles.additional_indentation}>
                          {(visualizedQueries?.includes(
                            templateQueryBuilderSchema?.form_uuid,
                          ) ||
                            visualizedQueries?.includes(
                              templateQueryBuilderSchema?.form_parent_uuid,
                            )) && (
                            <>
                              <EyeOutlined />{' '}
                            </>
                          )}
                          {templateQueryBuilderSchema.form_name}{' '}
                        </Text>
                        {/* <PlusOutlined /> */}
                      </Link>
                    </Tooltip>
                  </>
                }
              />
            </Menu.Item>
          );
        })}
      </Menu.SubMenu>

      {globalQueriesGroups?.map((global_query_group) => {
        let start_group = queryBuilderSchemas?.findIndex((e) =>
          e?.form_name?.startsWith(global_query_group),
        );
        let end_group = queryBuilderSchemas?.findLastIndex((e) =>
          e?.form_name?.startsWith(global_query_group),
        );

        return (
          <Menu.SubMenu
            data-cy={`queryBuilderSubMenu${global_query_group}Queries`}
            className={cx(
              styles.first_level_submenu,
              styles.exceptionBackground,
            )}
            title={
              <TitleAction
                menuKey={`global-queries-${global_query_group?.toLowerCase()}-submenu`}
                title={
                  <Text className={styles.additional_indentation} strong>
                    {global_query_group} Queries
                  </Text>
                }
                showDownArrow={props.isKeyOn(
                  `global-queries-${global_query_group?.toLowerCase()}-submenu`,
                )}
                titleAction={() =>
                  props.toggleKey(
                    `global-queries-${global_query_group?.toLowerCase()}-submenu`,
                  )
                }
              />
            }
            onTitleClick={(e) => {
              props.toggleKey(
                `global-queries-${global_query_group?.toLowerCase()}-submenu`,
              );
            }}
            key={`global-queries-${global_query_group?.toLowerCase()}-submenu`}
          >
            {queryBuilderSchemas
              ?.slice(start_group, end_group + 1)
              ?.map((qb) => {
                if (!props.mySubscriptionPlan?.has_access_to_query_builder) {
                  return props.returnSubstituteMenu({
                    type: 'subMenuItem',
                    tooltipMessage: (
                      <>
                        This Advanced Query is not part of this subscription
                        plan. To upgrade your subscription contact us at{' '}
                        <a target="_blank" href="mailto:sales@silentpush.com">
                          sales@silentpush.com
                        </a>
                        .
                      </>
                    ),
                    menuTitle: (
                      <>
                        {(visualizedQueries?.includes(qb?.form_uuid) ||
                          visualizedQueries?.includes(
                            qb?.form_parent_uuid,
                          )) && (
                          <>
                            <EyeOutlined />{' '}
                          </>
                        )}
                        {qb.form_name.startsWith(global_query_group)
                          ? qb.form_name.replace(
                              new RegExp(global_query_group + '\\s?-?\\s?'),
                              '',
                            )
                          : qb.form_name}
                      </>
                    ),
                    icon: null,
                  });
                } else {
                  return (
                    <Menu.Item
                      key={qb.form_uuid}
                      onClick={() => {
                        props.setSessionStorage(qb.form_uuid);
                      }}
                    >
                      <TitleAction
                        menuKey={qb.form_uuid}
                        titleAction={() => {
                          history.push(
                            `/explore/query-builder/?query=${qb.form_uuid}`,
                          );
                          dispatch(changeTitle(qb.form_name, null));
                          dispatch(
                            loadMergeAPIExploreQueryBuilderSchema(qb.form_uuid),
                          );
                        }}
                        title={
                          <>
                            <Tooltip
                              placement="right"
                              title={qb?.form_description}
                            >
                              <Link
                                className={styles.secondary_section_title}
                                to={`/explore/query-builder/?query=${qb.form_uuid}`}
                              >
                                <Text className={styles.additional_indentation}>
                                  {(visualizedQueries?.includes(
                                    qb?.form_uuid,
                                  ) ||
                                    visualizedQueries?.includes(
                                      qb?.form_parent_uuid,
                                    )) && (
                                    <>
                                      <EyeOutlined />{' '}
                                    </>
                                  )}
                                  {qb.form_name.startsWith(global_query_group)
                                    ? qb.form_name.replace(
                                        new RegExp(
                                          global_query_group + '\\s?-?\\s?',
                                        ),
                                        '',
                                      )
                                    : qb.form_name}
                                </Text>
                                {/* <PlusOutlined /> */}
                              </Link>
                            </Tooltip>
                          </>
                        }
                      />
                    </Menu.Item>
                  );
                }
              })}
          </Menu.SubMenu>
        );
      })}
    </Menu.SubMenu>
  );
}
